/**
 * Identité VisionPOS dans les applis d'authentification (2FA TOTP).
 * Sans `issuer`, Supabase met le domaine du projet (xxx.supabase.co) :
 * c'est ce nom technique que voyaient les utilisateurs dans leur appli.
 */
export const MFA_ISSUER = 'VisionPOS 360';

/** Icône « V » publique, lue par les applis qui gèrent le paramètre `image` (2FAS, FreeOTP, Ente…). */
export const MFA_LOGO_URL = 'https://pos.visionpos.fr/icon-512.png';

/** Ajoute le logo à l'URI otpauth:// renvoyée par Supabase (le secret reste inchangé). */
export const withMfaLogo = (otpauthUri: string): string => {
  const separator = otpauthUri.includes('?') ? '&' : '?';
  return `${otpauthUri}${separator}image=${encodeURIComponent(MFA_LOGO_URL)}`;
};
